// Token + backend-URL storage, shared between the task pane and the custom
// functions runtime via OfficeRuntime.storage. OfficeRuntime.storage is the
// documented mechanism for sharing data across those two separate runtimes,
// so a sign-in in the task pane is immediately visible to =LSEG.* calls.

import { DEFAULT_BACKEND_URL, STORAGE_KEYS } from "./config";

async function get(key: string): Promise<string | null> {
  try {
    const v = await OfficeRuntime.storage.getItem(key);
    return v ?? null;
  } catch {
    return null;
  }
}

async function set(key: string, value: string): Promise<void> {
  await OfficeRuntime.storage.setItem(key, value);
}

async function remove(key: string): Promise<void> {
  try {
    await OfficeRuntime.storage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export async function getBackendUrl(): Promise<string> {
  const v = await get(STORAGE_KEYS.backendUrl);
  return (v || DEFAULT_BACKEND_URL).replace(/\/+$/, "");
}

export async function setBackendUrl(url: string): Promise<void> {
  await set(STORAGE_KEYS.backendUrl, url.trim().replace(/\/+$/, ""));
}

export async function getAccessToken(): Promise<string | null> {
  return get(STORAGE_KEYS.accessToken);
}

export async function getRefreshToken(): Promise<string | null> {
  return get(STORAGE_KEYS.refreshToken);
}

export async function getUsername(): Promise<string | null> {
  return get(STORAGE_KEYS.username);
}

export async function setTokens(accessToken: string, refreshToken: string, username?: string): Promise<void> {
  await set(STORAGE_KEYS.accessToken, accessToken);
  await set(STORAGE_KEYS.refreshToken, refreshToken);
  if (username) await set(STORAGE_KEYS.username, username);
}

export async function clearTokens(): Promise<void> {
  await remove(STORAGE_KEYS.accessToken);
  await remove(STORAGE_KEYS.refreshToken);
  await remove(STORAGE_KEYS.username);
}
